/**
 * 注册路由
 * 2017-12-6
 */
"use strict";
angular.module("pgcSuccessRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("register.pgcsuccess",{
        url:"/pgcsuccess",
        views:{
            "main@register": {
                templateUrl: "./login/register/pgcSuccesspersonal/pgcSuccess_tpl.html",
                controller: "pgcSuccessCtrl"
            }
        }
    });
}]);